import { Component, OnInit } from "@angular/core";
import { fuseAnimations } from "@fuse/animations";
import { ActivatedRoute, Router } from "@angular/router";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";
import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";

import { DialogClienteComponent } from "../clientes/components/dialog-cliente/dialog-cliente.component";
import { DialogUsuarioComponent } from "./components/dialog-usuario/dialog-usuario.component";
import { DialogSucursalComponent } from "./components/dialog-sucursal/dialog-sucursal.component";

import { ClienteService } from "app/main/apps/shared/services/rest/cliente.service";
import { SucursalesService } from "app/main/apps/shared/services/rest/sucursales.service";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { UsuarioService } from "app/main/apps/shared/services/rest/usuario.service";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";

import { ClienteDTO } from "../../../shared/interfaces/cliente.interface";
import { SucursalPersonaDTO } from "app/main/apps/shared/interfaces/sucursal-persona.interface";
import { PersonaDTO } from "app/main/apps/shared/interfaces/persona.interface";
import { NuevoClienteDTO } from "app/main/apps/shared/models/cliente.model";
import { NuevoRepresentanteDTO } from "app/main/apps/shared/models/representante.model";
import { NuevaSucursalDTO } from "app/main/apps/shared/models/sucursal-model";
import { RolRepresentanteDTO } from "../../../shared/interfaces/usuario.interface";

import { config as CONFIG } from "app/app.config";

import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";

@Component({
    selector: "app-detalle-cliente",
    templateUrl: "./detalle-cliente.component.html",
    styleUrls: ["./detalle-cliente.component.scss"],
    animations: fuseAnimations,
})
export class DetalleClienteComponent implements OnInit {
    esSupervisor: boolean;
    esRepresentante: boolean;
    esEncargado: boolean;

    etiquetas: any;
    representantes: PersonaDTO;

    sucursales: SucursalPersonaDTO[];
    cliente: ClienteDTO;

    private subscripciones: Subscription;

    idCliente: number;

    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _dialogSrvc: DialogService,
        private _router: Router,
        private _activatedRouteSrv: ActivatedRoute,
        private _fuseProgressBarService: FuseProgressBarService,

        private _sucursalSrvc: SucursalesService,
        private _clienteSrvc: ClienteService,
        private _menuUsuarioSrvc: MenuUsuarioService,
        private _usuarioSrvc: UsuarioService,
        private _notificacionSrvc: NotificacionesService
    ) {
        this.subscripciones = new Subscription();
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
        this.etiquetas = {
            ficha: "Ficha cliente",
            sucursales: "Sucursales",
            representantes: "Representantes",
        };
    }

    ngOnInit(): void {
        this.esSupervisor = this._menuUsuarioSrvc.esSupervisor();
        this.esEncargado = this._menuUsuarioSrvc.esEncargado();
        this.esRepresentante = this._menuUsuarioSrvc.esRepresentante();

        this.subscripciones.add(
            this._activatedRouteSrv.params.subscribe((params) => {
                if (Object.keys(params).length > 0) {
                    this.idCliente = params["idCliente"];

                    //console.log(this.idCliente);

                    this.getCliente(this.idCliente);

                    //Sucursales sin paginacion
                    this.obtenerSucursales();

                    //Representantes sin paginacion
                    if (this.esSupervisor) {
                        this.obtenerRepresentantes();
                    }
                }
            })
        );
    }

    obtenerRepresentantes(): void {
        this.subscripciones.add(
            this._clienteSrvc
                .fetchRepresentantes(this.idCliente)
                .subscribe((representantes) => {
                    this.representantes = representantes;
                })
        );
    }

    obtenerSucursales(): void {
        this.subscripciones.add(
            this._sucursalSrvc
                .fetchSucursalesCliente(this.idCliente)
                .subscribe((sucursales) => {
                    this.sucursales = sucursales;
                })
        );
    }

    eliminarCliente(event) {
        const dialogRef = this._dialogSrvc.abrirDialogConfirm(
            "Eliminar cliente",
            "Favor confirme si realmente quiere realizar la eliminación del cliente"
        );
    }

    editarCliente(event) {
        //console.log(event);
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogClienteComponent,
            "clase-dialog",
            "500px",
            {
                editar: true,
                cliente: {
                    razonSocial: this.cliente.nombre,
                    rut: this.cliente.rut,
                },
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this._fuseProgressBarService.show();
                let nuevo = new NuevoClienteDTO(
                    result.rut.split("-")[0],
                    result.rut.split("-")[1],
                    result.razonSocial
                );
                this.subscripciones.add(
                    this._clienteSrvc
                        .save(nuevo)
                        .pipe(finalize(()=>{this._fuseProgressBarService.hide();}))
                        .subscribe((resp) => {
                            //console.log(resp);
                            this.getCliente(this.idCliente);
                    })
                );
            }
        });
    }

    editarRepresentante(event) {
        //console.log(event);
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogUsuarioComponent,
            "clase-dialog",
            "500px",
            {
                editar: true,
                usuario: event,
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            let nuevo = new NuevoRepresentanteDTO(
                event.nrRut,
                event.dv,
                //event.rut,
                result.nombres,
                result.apellidos,
                result.correo
            );

            if (result) {
                this._fuseProgressBarService.show();
                this.subscripciones.add(
                    this._clienteSrvc
                        .saveRepresentante(this.idCliente, nuevo)
                        .pipe(finalize(()=>{this._fuseProgressBarService.hide();}))
                        .subscribe((resp) => {
                            this.representantes = null;
                            this.obtenerRepresentantes();
                        })
                );
            }
        });
    }

    editarSucursal(sucursal) {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogSucursalComponent,
            "clase-dialog",
            "500px",
            {
                editar: true,
                sucursal: sucursal,
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                let nuevo = new NuevaSucursalDTO(
                    result.nombre,
                    result.direccion,
                    result.idComuna,
                    result.telefono
                );
                this._sucursalSrvc
                    .update(sucursal.id, nuevo)
                    .subscribe((resp) => {
                        this.sucursales = null;
                        this.obtenerSucursales();
                    });
            }
        });
    }

    nuevaSucursal() {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogSucursalComponent,
            "clase-dialog",
            "500px",
            {
                editar: false,
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this._fuseProgressBarService.show();
                let nuevo = new NuevaSucursalDTO(
                    result.nombre,
                    result.direccion,
                    result.idComuna,
                    result.telefono
                );
                this._sucursalSrvc
                    .save(this.idCliente, nuevo)
                    .pipe(finalize(()=>{this._fuseProgressBarService.hide();}))
                    .subscribe((resp) => {
                        this.sucursales = null;
                        this.obtenerSucursales();
                    });
            }
        });
    }

    nuevoRepresentante() {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogUsuarioComponent,
            "clase-dialog",
            "500px",
            {
                editar: false,
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this._fuseProgressBarService.show();
                let nuevo = new NuevoRepresentanteDTO(
                    result.rut.split("-")[0],
                    result.rut.split("-")[1],
                    result.nombres,
                    result.apellidos,
                    result.correo
                );
                this._clienteSrvc
                    .saveRepresentante(this.idCliente, nuevo)
                    .pipe(finalize(()=>{this._fuseProgressBarService.hide();}))
                    .subscribe((resp) => {
                        this._notificacionSrvc.mostrarNotificacion(
                            "El representante ha sido exitosamente registrado",
                            "success"
                        )
                        this.representantes = null;
                        this.obtenerRepresentantes();
                    });
            }
        });
    }

    getCliente(idCliente: number) {
        if (this.esRepresentante) {
            const perfilUsuario = this._usuarioSrvc.getPerfil();
            const rolRepresentante = <RolRepresentanteDTO[]>(
                perfilUsuario.roles.filter(
                    (rol) => rol.id === CONFIG.roles.representante.rol
                )
            );
            this.cliente=rolRepresentante[0].cliente;
        } else {
            this.subscripciones.add(
                this._clienteSrvc
                    .fetchDetalleCliente(idCliente)
                    .subscribe((resp) => (this.cliente = resp))
            );
        }
    }

    desactivar(idCliente: number) {
        this._fuseProgressBarService.show();
        this.subscripciones.add(
            this._clienteSrvc
                .disableCliente(idCliente)
                .pipe(finalize(() => this._fuseProgressBarService.hide()))
                .subscribe((resp) => {

                    this._notificacionSrvc.mostrarNotificacion(
                        "Cliente desactivado",
                        "success"
                    );

                    this._clienteSrvc
                        .fetchDetalleCliente(this.idCliente)
                        .subscribe((resp) => {
                            this._clienteSrvc.clienteStatusChanged$.next(resp);
                    })    
                })
        );
    }

    activar(idCliente: number) {
        this._fuseProgressBarService.show();
        this.subscripciones.add(
            this._clienteSrvc
                .enableCliente(idCliente)
                .pipe(finalize(() => this._fuseProgressBarService.hide()))
                .subscribe((resp) => {
                    this._notificacionSrvc.mostrarNotificacion(
                        "Cliente activado",
                        "success"
                    );

                    this._clienteSrvc
                        .fetchDetalleCliente(this.idCliente)
                        .subscribe((resp) => {
                            this._clienteSrvc.clienteStatusChanged$.next(resp);
                    })
                })
        );
    }

 
    cambiarEstadoCliente(cliente:ClienteDTO){
        let activado = cliente.fechaTermino == null ? true : false;

        let mensaje = "Favor confirme si realmente quiere realizar";
        if (activado) {
            mensaje = mensaje + " la desactivacion del cliente";
        } else {
            mensaje = mensaje + " la activación del cliente";
        }
        const dialogRef = this._dialogSrvc.abrirDialogConfirm(
            activado ? "Desactivar cliente" : "Activar cliente",
            mensaje
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                if (activado) {
                    this.desactivar(cliente.id);
                } else {
                    this.activar(cliente.id);
                }
            }
            else{
                this._clienteSrvc.clienteStatusChanged$.next(cliente);
            }
        });
    }

    borrarSucursal(event): void {
        const dialogRef = this._dialogSrvc.abrirDialogConfirm(
            "Eliminar Sucursal",
            "Favor confirme si realmente quiere realizar la eliminación de la sucursal"
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log(result);
            if (result) {
                this._sucursalSrvc.delete(event).subscribe((resp) => {
                    this.sucursales = null;
                    this.obtenerSucursales();
                });
            }
        });
    }

    borrarRepresentante(event): void {
        //console.log(event);
        const dialogRef = this._dialogSrvc.abrirDialogConfirm(
            "Eliminar Representante",
            "Favor confirme si realmente quiere realizar la eliminación del representante "
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log(result);
            if (result) {
                this._clienteSrvc
                    .delete(event.idCliente, event.nrRut)
                    .subscribe((resp) => {
                        this.representantes = null;
                        this.obtenerRepresentantes();
                    });
            }
        });
    }

    verEncargados(idSucursal: number) {
        //console.log(idSucursal);
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
